export const TYPE = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  SET_LOGIN_PROCESS_INDICATOR: 'SET_LOGIN_PROCESS_INDICATOR',
};

/**
 * Login action
 *
 * @param {{userName: string, name:string, authMode:string, token:string, roles:string[]}} data
 *
 * @returns {{type: string, payload: object}} The action object
 */
export function login(data:any) {
  return {
    type: 'login',
    payload: data,
  };
}

/**
 * Logout action
 *
 * @returns {{type:string}} The action object
 */
export function logout() {
  return {
    type: TYPE.LOGOUT,
  };
}